
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getSummary(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/summary?${query}`, { headers: authHeader() });
    },
    getMonthlyComparison(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/monthly-comparison?${query}`, { headers: authHeader() });
    },
    getWeeklyBreakdown(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/weekly-breakdown?${query}`, { headers: authHeader() });
    },
    getDailyBreakdown(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/daily-breakdown?${query}`, { headers: authHeader() });
    },
    getYearlyComparison(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/yearly-comparison?${query}`, { headers: authHeader() });
    },
    getTechnicianTracking(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/technician-tracking?${query}`, { headers: authHeader() });
    },
    getCustomerRepurchase(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/customer-repurchase?${query}`, { headers: authHeader() });
    },
    getOilChangeReminders(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/oil-change-reminders?${query}`, { headers: authHeader() });
    },
    getInventoryTracking(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/inventory-tracking?${query}`, { headers: authHeader() });
    },
    getPartsBalance(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/parts-balance?${query}`, { headers: authHeader() });
    },
    getLaborByService(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/metrics/labor-by-service?${query}`, { headers: authHeader() });
    },
};
